import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PracticeCard from './PracticeCard';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import { useLocation, useHistory } from "react-router";
import { Auth } from 'aws-amplify';
import { checkPremiumStatus } from '../../utils/auth';
import { UserContext } from '../UserContext';

import batchImg from '../../assets/images/practics-banner.png';
import { cx } from '@emotion/css';
import * as styles from './practice.style.js';

function PracticeScreen(props) {
  const [events, set_events] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useContext(UserContext);
  const history = useHistory();

  

  let data1 = useLocation();

  function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

  const loadEvents = (isUserPremium = false) => {
    console.log('Loading events with state:', data1.state);
    const category = data1.state["category"];
    const level = data1.state["level"];
    const premiumlevel = data1.state["premiumlevel"] || 0; // Default to 0 if not provided
    console.log('Category:', category, 'Level:', level, 'Premium Level:', premiumlevel);
    console.log('User premium status:', isUserPremium);
    
    // Update the state for other components
    setIsPremium(isUserPremium);

    const quizes = importAll(require.context("./resources/", true, /\.(json)$/));
    const keys = Object.keys(quizes);
    let serialnumber = 0;
    const data12 = [];
    let time = 120;

    if (category === "SpellBowl") {
      time = 10;
    }

    for (let i = 0; i < keys.length; i++) {
      if (keys[i].includes(category) && keys[i].includes('Grade' + level)) {
        const processQuiz = () => {
          serialnumber += 1;
          const filename = keys[i].replace(/^.*[\/]/, '');
          // Remove all occurrences of ".json" from the display name (handles files like
          // "... 2025.json with upper cases.json" -> "... 2025 with upper cases")
          let name = filename.replace(/\.json/gi, '').trim();
          // Custom title for "Senior Word List 2025_filtered"
          if (name === "Senior Word List 2025_filtered") {
            name = "Foreign origin words";
          }
          // Custom title for "Elementary Word List 2025_filtered"
          if (name === "Elementary Word List 2025_filtered") {
            name = "Foreign origin words";
          }
          // Custom title for "Junior Word List 2025_filtered"
          if (name === "Junior Word List 2025_filtered") {
            name = "Foreign origin words";
          }
          const quizData = quizes[keys[i]];
          const questions = quizData.questions || quizData;

          const json_object = {
            completed: 0,
            eventtype: 'Practice',
            evenstartdate: '2020-0-31',
            levels: ['Grade' + level],
            category: category,
            totalquestions: questions.length,
            level: 'Grade' + level,
            name: name,
            eventdisplay: '',
            qualificationno: questions.length - 1,
            time: time,
            questions: questions,
            id: serialnumber
          };

          data12.push(json_object);
        };

        if (keys[i].includes("premium")) {
          console.log('Found premium content:', keys[i]);
          try {
            const premiumlabel = keys[i].substring(keys[i].indexOf('premium'), keys[i].lastIndexOf('/'));
            const premiumnumber = parseInt(premiumlabel.split("premium")[1], 10);
            console.log('Premium level check:', { premiumnumber, premiumlevel, isUserPremium });
            
            // Show premium0 content to all users, and other premium content to premium users
            if (premiumnumber === 0 || (isUserPremium && premiumnumber <= premiumlevel)) {
              console.log('Processing content for user');
              processQuiz();
            } else {
              console.log('Skipping premium content - user does not have access');
            }
          } catch (e) {
            console.error('Error processing premium content:', e);
          }
        } else {
          // Always process non-premium content
          processQuiz();
        }
      }
    }

    set_events(data12);
    set_loadedevents(true);
  };

  useEffect(() => {
    const checkAndLoad = async () => {
      console.log('Checking premium status...');
      try {
        const { isPremium: premiumStatus } = await checkPremiumStatus();
        console.log('Premium status from check:', premiumStatus);
        // Pass the premium status directly to loadEvents
        loadEvents(premiumStatus);
      } catch (error) {
        console.error('Error checking premium status, loading free content', error);
        loadEvents(false);
      }
    };
    
    checkAndLoad();
    document.title = 'Practice';
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  let eventCards = events.map(event => {
    return (
      <div className='col-md-4' key={event.id}>
        <Col className="py-2 border rounded" key={event.id}>
          <PracticeCard
            imgsrc={"../assets/" + event.name + ".png"}
            title={event.name}
            key={event.id}
            levels={event.levels}
            totalquestions={event.totalquestions}
            event={event}
            category={data1.state}
          />
        </Col>
      </div>
    );
  });

  return (
    <div>
      {loadedevents ? (
        <div>
          <div className={cx(styles.batchBanner)}>
            <img src={batchImg} alt="" />

          </div>
          <div className={cx(styles.batchTitle)}>Let's Practice Cool Stuff</div>

          {data1.state["category"].includes("SpellBowl") ? (
            <div className={cx(styles.spellbowllicense)}>
              All Word Lists utilized herein have been provided by the Indiana Association of School Principals, Inc.
            </div>
          ) : null}

          <div className={cx(styles.allPracticeFluid)}>
            <Row>{eventCards}</Row>
          </div>
        </div>
      ) : (
        <div className="welcomecenter">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      )}
    </div>
  );
}

export default PracticeScreen;